import { Typography, type TypographyProps, useTheme } from "@mui/material";
import type { ReactNode } from "react";

type Props = { children: ReactNode } & TypographyProps;

//TODO: (nice to have) use this component for all error texts in the app
export const ErrorText = ({ children, ...restProps }: Props) => {
  const theme = useTheme();

  return (
    <Typography
      color={theme.palette.error.main}
      fontWeight={600}
      {...restProps}
    >
      {children}
    </Typography>
  );
};
